import { FC } from 'react';

import { MagicLinkLoginData } from '@/api/magicLink/magicLink.types';
import Button from '@/components/controls/Button';

type MagicLinkSentProps = {
  email: string;
  resendLink: (data: MagicLinkLoginData) => void;
};

const MagicLinkSent: FC<MagicLinkSentProps> = ({ email, resendLink }) => {
  const resendLinkHandler = (): void => {
    resendLink({ email });
  };

  return (
    <div className="flex flex-col items-center text-base text-center text-gray-700">
      <h5 className="text-2xl mt-4 font-bold">Check your email</h5>
      <p className="self-stretch mt-1">We emailed a magic link to: </p>
      <div className="self-stretch">
        <p className="font-bold">{email}</p>
      </div>
      <p>Click the link to log in.</p>
      <Button
        buttonStyle="justify-center items-center px-6 py-2 mt-7 text-base font-semibold text-white whitespace-nowrap bg-honoursOrange rounded-xl max-md:px-5 w-full text-lg"
        text="Resend link"
        buttonType={{ type: 'button' }}
        hasImage={false}
        onClick={resendLinkHandler}
      />
    </div>
  );
};

export default MagicLinkSent;
